export function showFirstSixWords(str) {
    // Split the string into an array of words
    let words = str.split(' ');

    // Check if the array has at least 6 words
    if (words.length >= 7) {
        // If yes, join the first six words and return
        return words.slice(0, 7).join(' ') + '...';
    } else {
        // If no, return the original string
        return str;
    }
}
export function showFirstFourWords(str) {
    // Split the string into an array of words
    let words = str.split(' ');

    // Check if the array has at least 6 words
    if (words.length >= 4) {
        // If yes, join the first six words and return
        return words.slice(0, 4).join(' ') + '...';
    } else {
        // If no, return the original string
        return str;
    }
}
export function showFirst22Words(str) {
    // Split the string into an array of words
    let words = str.split(' ');

    // Check if the array has at least 6 words
    if (words.length >= 22) {
        // If yes, join the first six words and return
        return words.slice(0, 22).join(' ') + '...';
    } else {
        // If no, return the original string
        return str;
    }
}
export function showFirst12Words(str) {
    // Split the string into an array of words
    let words = str.split(' ');

    // Check if the array has at least 6 words
    if (words.length >= 12) {
        // If yes, join the first six words and return
        return words.slice(0, 12).join(' ') + '...';
    } else {
        // If no, return the original string
        return str;
    }
}
export function showFirst17Words(str) {
    // Split the string into an array of words
    let words = str.split(' ');

    // Check if the array has at least 6 words
    if (words.length >= 17) {
        // If yes, join the first six words and return
        return words.slice(0, 17).join(' ') + '...';
    } else {
        // If no, return the original string
        return str;
    }
}

export function getFirstAndLastWords(str) {
    return str;
    const words = str.split(/[\s,]/); //  Split by spaces, commas, or any whitespace characters
    return {
        firstWord: words[0],
        lastWord: words[words.length - 1]
    };
}

function removeHtmlTags(input) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = input;
    return tempDiv.textContent || tempDiv.innerText || "";
}

export function showWordsByNumber(str, numberorWords = 0, newLineOnClosingtag = false, translate = () => { }) {
    let cleanStr = str;

    if (!newLineOnClosingtag) {
        cleanStr = removeHtmlTags(str);
    }
    // Split into words
    const words = cleanStr.split(/\s+/);

    // Return limited words or original
    if (words.length >= numberorWords) {
        let sliced = words.slice(0, numberorWords).join(' ');

        if (newLineOnClosingtag) {
            // Reconstruct part of the original HTML while preserving tag integrity
            const parser = new DOMParser();
            const doc = parser.parseFromString(`<div>${sliced}</div>`, 'text/html');
            let closedHtml = doc.body.innerHTML;

            // Append underline word after ensuring tags are closed
            return `${closedHtml}<u class="text-dark fw-bold" style="cursor:pointer;">${translate('web.seeMore', 'See More')}</u>`;
        } else {
            return sliced;
        }
    } else {
        return cleanStr;
    }
}

